import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import moment from 'moment';

import Help from '../../generics/help';

const Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class Autoexclution extends Component {
    constructor(props) {
        super(props);

        this.onSearch = this.onSearch.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onClear = this.onClear.bind(this);
        this.getValues = this.getValues.bind(this);

        this.state = {
            offers:[],
            offer_id:"",
            donor_name:"",
            date:"",
            donor_self_exclusion:"",
            permanent_rejection:"",
            bag_rejection:"",
            bag_incident:"",
            saved_donor:false,
            saved_permanent:false,
            saved_rejection:false,
            saved_incident:false,
            id:"",
        }
    }

    componentDidMount(){
        var id = this.props.match.params.id;

        if(id !== undefined){
        
            this.getValues(id);
        }
    }

    getValues(id){
        fetch(Config.default.apiGateway.URL+'self_exclusion/'+id,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {                
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({
                    offer_id: response.exclusion.offer_id,
                    donor_name: response.donor,
                    date: moment(response.timestamp_date).format('DD/MM/YYYY')+' '+
                        moment(response.timestamp_hour, 'HH:mm:ss:sssssss').format('HH:mm:ss'),
                    donor_self_exclusion: response.exclusion.donor_self_exclusion !== null ? response.exclusion.donor_self_exclusion : "",
                    permanent_rejection: response.exclusion.permanent_rejection !== null ? response.exclusion.permanent_rejection : "",
                    bag_rejection: response.exclusion.bag_rejection !== null ? response.exclusion.bag_rejection : "",
                    bag_incident: response.exclusion.bag_incident !== null ? response.exclusion.bag_incident : "",
                    id:response.exclusion.id,
                    saved_donor: response.exclusion.donor_self_exclusion !== null,
                    saved_permanent: response.exclusion.permanent_rejection !== null,
                    saved_rejection: response.exclusion.bag_rejection !== null,
                    saved_incident: response.exclusion.bag_incident !== null,
                });
            }
        })
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    onSearch(query){
        if(query !== undefined){
            fetch(Config.default.apiGateway.URL+'donors/last_days?hf_id='+sessionStorage.getItem('health_facilities_id')+
                '&search='+query,{
                method:'GET',
                headers: new Headers({
                    'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                    'Accept'        : 'application/json',
                    'Content-Type'  : 'application/json'
                })
            }).then(res => {                
                if(res.ok){
                    return res.json();
                }else{
                    res.text().then((msg) => {
                        swal('Error', msg, 'error');
                    });
                }
            }).then(response => {
                if(response !== undefined){
                    this.setState({offers: response})
                }
            })
        }
    }

    onSelect(e){
        if(e.length > 0){
            this.setState({
                offer_id: e[0].id,
                donor_name: e[0].donor_name,
                date: moment(e[0].timestamp_date).format('DD/MM/YYYY')+' '+moment(e[0].timestamp_hour, 'HH:mm:ss.sssssss').format('HH:mm')
            });
        }
    }

    onSave(e){
        e.preventDefault();

        if(this.isValidForm()){

            var obj = {
                offer_id: this.state.offer_id,
                donor_self_exclusion: this.state.donor_self_exclusion,
                permanent_rejection: this.state.permanent_rejection,
                bag_rejection: this.state.bag_rejection,
                bag_incident: this.state.bag_incident
            }

            var url = 'self_exclusion';
            var method = 'POST';

            if(this.state.id !== ""){
                url = 'self_exclusion/'+this.state.id;
                method = 'PUT';

                obj.id = this.state.id;
            }

            if(this.state.donor_self_exclusion !== "" || this.state.permanent_rejection !== "" ||
                this.state.bag_rejection !== "" || this.state.bag_incident !== ""
            ){
                this.props.waiting.handleShow('Guardando...');
                fetch(Config.default.apiGateway.URL+url,{
                    method:method,
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'        : 'application/json',
                        'Content-Type'  : 'application/json'
                    })
                }).then(res => {                
                    this.props.waiting.handleClose();
                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg) => {
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined){
                        this.props.history.push('/autoexclution');
                        
                    }
                });
            }else{
                swal('Error', 'Debe de contestar por lo menos una pregunta', 'error');
            }            
        }else{
            swal('Error', 'Campos incompletos', 'error');
        }
    }

    onClear(){
        this.setState({
            offers:[],
            offer_id:"",
            donor_name:"",
            date:"",
            donor_self_exclusion:true,
            permanent_rejection:true,
            bag_rejection:true,
            bag_incident:true
        });

        this._typeahead.getInstance().clear();
        this._typeahead.getInstance().focus();
    }

    isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    var vacio = false;

	    inputs.forEach(input => {	    	
            if(input.required){
                const isInputValid = this.showCtrlError(input.id);
                if (!isInputValid) {
                    vacio = true;
                }
            }
	    });

	    if(vacio){
	    	isFormValid = false;
	    }

	    return isFormValid;
    }
    
    showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);		
			
        if(control !== null){
            if(control.required){
                if(control.value === ""){
                    control.classList.add('error');
                    res = false;
                    
                }else{
                    if(control.className.includes('error')){
                        control.classList.remove('error');
                        
                    }
                    res = true;
                }

            }
        }
							
		return res;
		
	}

    render() {
        const {t} = this.props;
        return (
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page" >
                        {session} ->
                        {t('sidebar.nav.donors.MAIN')} -> 
                        Autoexcluciôn
                    </h5>
                </div>

                <Help
                    {...this.props}
                    menu={"help_donors"} 
                    submenu={"help_self_exclusion"}  />

                {this.state.id === "" &&
                    <div className="col-xs-12">
                        <div className="col-xs-12 col-sm-4">
                            <AsyncTypeahead
                                labelKey={(option) => `${option.donor_name}`}
                                minLength={0}
                                name="donor"
                                id="donor" 
                                inputProps={{
                                    autoComplete:"off",
                                    name:'donor_id',
                                    id:'donor_id'
                                }}
                                options={this.state.offers}
                                onSearch={this.onSearch}
                                onChange={this.onSelect} 
                                ref={ref => this._typeahead = ref}
                                delay={600}
                                paginationText="Mostrar mas resultados..."
                                placeholder="Nombre de donador"
                            />
                        </div>
                    </div>
                }

                <div className="col-xs-12">
                    <hr/>
                    <div className="col-xs-12">
                        <span className="span-min col-sm-3 col-md-5 col-lg-2">Ofrecimiento</span> <span>{this.state.offer_id}</span>
                    </div>
                    <div className="col-xs-12">
                        <span className="span-min col-sm-3 col-md-5 col-lg-2">Nombre de donador</span> <span>{this.state.donor_name}</span>
                    </div>
                    <div className="col-xs-12">
                        <span className="span-min col-sm-3 col-md-5 col-lg-2">Fecha</span> <span>{this.state.date}</span>
                    </div>
                </div>

                <div className="col-xs-12 form-group">
                    <hr/>
                    <div className="col-xs-12 form-group">
                        <div className="col-sm-3 col-md-5 col-lg-3">
                            <span className="span-min">
                                Desea hacer la autoexclusión del donador?
                            </span> 
                        </div>
                        <div className="col-sm-1">
                            <select className="form-control input-sm col-xs-4 col-sm-1"
                                name="donor_self_exclusion" id="donor_self_exclusion" value={this.state.donor_self_exclusion} 
                                onChange={(e)=>this.handleChange(e)}
                                disabled={this.state.saved_donor}
                            >
                                <option value="">Seleccione...</option>
                                <option value={true}>Si</option>
                                <option value={false}>No</option>
                            </select>
                        </div>                        
                    </div>
                    <div className="col-xs-12 form-group">
                        <div className="col-sm-3 col-md-5 col-lg-3">
                            <span className="span-min">
                                Desea hacer un rechazo permantente a este donador?
                            </span> 
                        </div>
                        <div className="col-sm-1">
                            <select className="form-control input-sm col-xs-4 col-sm-1"
                                name="permanent_rejection" id="permanent_rejection" value={this.state.permanent_rejection} onChange={(e)=>this.handleChange(e)}
                                required={this.state.donor_self_exclusion === 'true'}
                                disabled={this.state.saved_permanent}
                            >
                                <option value="">Seleccione...</option>
                                <option value={true}>Si</option>
                                <option value={false}>No</option>
                            </select>
                        </div>                        
                    </div>
                    <div className="col-xs-12 form-group">
                        <div className="col-sm-3 col-md-5 col-lg-3">
                            <span className="span-min">
                                Desea rechazar esta bolsa?
                            </span> 
                        </div>
                        <div className="col-sm-1">
                            <select className="form-control input-sm col-xs-4 col-sm-1"
                                name="bag_rejection" id="bag_rejection" value={this.state.bag_rejection} onChange={(e)=>this.handleChange(e)}
                                required={this.state.donor_self_exclusion === 'true'}
                                disabled={this.state.saved_rejection}
                            >
                                <option value="">Seleccione...</option>
                                <option value={true}>Si</option>
                                <option value={false}>No</option>
                            </select>
                        </div>                        
                    </div>
                    <div className="col-xs-12 form-group">
                        <div className="col-sm-3 col-md-5 col-lg-3">
                            <span className="span-min">
                                Desea dar de baja esta bolsa?
                            </span> 
                        </div>
                        <div className="col-sm-1">
                            <select className="form-control input-sm col-xs-4 col-sm-1"
                                name="bag_incident" id="bag_incident" value={this.state.bag_incident} onChange={(e)=>this.handleChange(e)}
                                required={this.state.donor_self_exclusion === 'true'}
                                disabled={this.state.saved_incident}
                            >
                                <option value="">Seleccione...</option>
                                <option value={true}>Si</option>
                                <option value={false}>No</option>
                            </select>
                        </div>                        
                    </div>
                </div>
                <div className="col-xs-12" style={{textAlign:'center'}}>
                    <button className="btn btn-info" onClick={()=>this.props.history.push('/autoexclution')} style={{marginRight:8}}>Cancelar</button>
                    <button className="btn btn-info" onClick={(e)=>this.onSave(e)} disabled={this.state.donor_name === ""}>Guardar</button>
                </div>
            </div>
        )
    }
}

export default translate('translations')(Autoexclution);